setTimeout(()=>{
    let popUpSupplement = document.querySelector(".pop-up__image-supplement--trigger");
    if (popUpSupplement) {
        let popUp = document.createElement('div');
        popUp.className = 'pop-up__image-supplement';
        popUp.innerHTML = `<div class="supplement__content">
                                <img src="https://cdn.shopify.com/s/files/1/0559/4805/0622/files/pop-up-supplements-img.jpg" height="420" width="420">
                            </div>`;
        document.body.append(popUp);


        popUpSupplement.addEventListener("click", event => {
            event.preventDefault();
            document.body.style.overflow = "hidden";
            popUp.classList.add("open");

        })
        popUp.addEventListener("click", event => {
            popUp.classList.remove("open");
            document.body.style.overflow = "visible";
        })
    }
}, 500);